export const customEn = {
  StepsTitle: 'Meet Your Riding Partner Today'
};
export const customEs = {
    StepsTitle: 'Conoce a tu compañero de equitación hoy'
};
export const customDa = {
    StepsTitle: 'Mød din ridepartner i dag'
};
export const customDe = {
    StepsTitle: 'Triff heute deinen Reitpartner'
};
export const customFi = {
    StepsTitle: 'Tapaa ratsastuskumppanisi tänään'
};
export const customSv = {
    StepsTitle: 'Möt din ridpartner idag'
};
export const customFr = {
    StepsTitle: 'Rencontrez votre partenaire d’équitation dès aujourd’hui'
};
export const customHu = {
    StepsTitle: 'Találkozz lovagló partnereddel még ma'
};




// WEBPACK FOOTER //
// ./src/constants/custom.localization.js